(() => {
  const DESKTOP = '(min-width: 990px)';

  function initComponentsMenu(root = document) {
    root.querySelectorAll('[data-kb-components-menu]').forEach((menu) => {
      if (menu.dataset.kbReady === 'true') return;
      menu.dataset.kbReady = 'true';

      const tabs = Array.from(menu.querySelectorAll('[data-kb-component-tab]'));
      const panels = Array.from(menu.querySelectorAll('[data-kb-component-panel]'));

      const activate = (index) => {
        tabs.forEach((tab) => {
          const active = tab.dataset.kbComponentTab === String(index);
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
        });

        panels.forEach((panel) => {
          const active = panel.dataset.kbComponentPanel === String(index);
          panel.classList.toggle('is-active', active);
          panel.hidden = !active;
        });
      };

      tabs.forEach((tab) => {
        const index = tab.dataset.kbComponentTab;

        tab.addEventListener('click', () => activate(index));

        tab.addEventListener('mouseenter', () => {
          if (window.matchMedia(DESKTOP).matches) activate(index);
        });

        tab.addEventListener('keydown', (event) => {
          const current = tabs.indexOf(tab);
          let next = null;

          if (event.key === 'ArrowDown' || event.key === 'ArrowRight') {
            next = tabs[(current + 1) % tabs.length];
          }

          if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') {
            next = tabs[(current - 1 + tabs.length) % tabs.length];
          }

          if (next) {
            event.preventDefault();
            next.focus();
            activate(next.dataset.kbComponentTab);
          }
        });
      });
    });
  }

  function initMegaDetails(root = document) {
    const details = Array.from(root.querySelectorAll('.kb-mega-menu'));

    details.forEach((item) => {
      if (item.dataset.kbMenuReady === 'true') return;
      item.dataset.kbMenuReady = 'true';

      item.addEventListener('toggle', () => {
        if (!item.open) return;

        details.forEach((other) => {
          if (other !== item) other.removeAttribute('open');
        });
      });
    });
  }

  function init(root = document) {
    initComponentsMenu(root);
    initMegaDetails(root);
  }

  document.addEventListener('DOMContentLoaded', () => init(document));

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target || document);
  });
})();
